export const PENDING_ADDRESS_KEY = 'nn_pending_address';

export const stashPendingAddress = (shipping) => {
  if (typeof sessionStorage === 'undefined' || !shipping) return;
  try {
    sessionStorage.setItem(
      PENDING_ADDRESS_KEY,
      JSON.stringify({
        fullName: shipping.fullName || '',
        email: shipping.email || '',
        addressLine1: shipping.addressLine1 || '',
        addressLine2: shipping.addressLine2 || '',
        city: shipping.city || shipping.locality || '',
        state: shipping.state || shipping.administrativeDistrictLevel1 || '',
        postalCode: shipping.postalCode || '',
        country: shipping.country || 'US',
        label: shipping.label || null,
      })
    );
  } catch (err) {
    // ignore quota / private mode
  }
};

export const readPendingAddress = () => {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(PENDING_ADDRESS_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    return null;
  }
};

export const clearPendingAddress = () => {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(PENDING_ADDRESS_KEY);
  } catch (err) {
    // ignore
  }
};

export const splitFullName = (fullName) => {
  if (fullName == null || fullName === '') {
    return { firstName: '', lastName: '' };
  }
  const parts = String(fullName)
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  // Guard against String(null) => "null" if a bad value slips through
  if (!parts.length || parts[0].toLowerCase() === 'null') {
    return { firstName: '', lastName: '' };
  }
  if (parts.length === 1) return { firstName: parts[0], lastName: '' };
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
  };
};

/** Persist a stashed checkout address after the guest creates an account. */
export const savePendingAddressIfAny = async (axios) => {
  const pending = readPendingAddress();
  if (!pending || !pending.addressLine1) return;
  try {
    await axios.post('/api/addresses', {
      ...pending,
      isDefault: true,
    });
    clearPendingAddress();
  } catch (err) {
    // Keep stashed so Account page can retry; don't fail signup.
    console.error('Could not save pending address:', err.message);
  }
};

export const formatAddressLines = (address) => {
  if (!address) return [];
  const city = address.city || address.locality || '';
  const state =
    address.state || address.administrativeDistrictLevel1 || '';
  const line3 = [city, state, address.postalCode].filter(Boolean).join(', ');
  return [
    address.fullName,
    address.addressLine1,
    address.addressLine2,
    line3,
    address.country && address.country !== 'US' ? address.country : null,
  ].filter(Boolean);
};
